var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 13.3853V19.6158C20.9997 19.983 20.8538 20.3353 20.5941 20.5949C20.3345 20.8545 19.9823 21.0004 19.6151 21.0004H4.38482C4.0176 21.0004 3.66543 20.8545 3.40578 20.5949C3.14612 20.3353 3.00024 19.983 3.00024 19.6158V4.38555C3.00024 4.01833 3.14612 3.66617 3.40578 3.40651C3.66543 3.14685 4.0176 3.00098 4.38482 3.00098H10.6154",
    stroke: "#8C8B8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1536 3.00098H20.9996V7.84698",
    stroke: "#8C8B8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 3.00098L12 12.0007",
    stroke: "#8C8B8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.da6dc1e73a618d0ae9480cbb21e2da8e.svg";
export { ForwardRef as ReactComponent };